import { composeIO } from 'react-compose-io'
import { itemLancamentoIO } from './ItemLancamento.IO'
import { ItemLancamentoView } from './ItemLancamento.View'

export const ItemLancamento = composeIO(ItemLancamentoView, itemLancamentoIO)
